import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import CreateTeacherModal from "../modals/CreateTeacherModal";
import SearchBar from "../Components/common/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { CSVLink } from "react-csv";
import {
  multiSchoolAdmincreateAction,
  multiTeachercreateAction,
  resetTeacherAction,
  teacherListAction,
} from "../Redux/Action/teacherAction";
import { Encryptedid } from "../Util/BcruptEncyptid";
import LoaderComponent from "../Components/common/LoaderComponent";
import TopHeader from "../Components/TopHeader";
import {
  uploadSchoolAdminCSV,
  uploadStudentCSV,
  uploadTeacherCSV,
} from "../Util/HelperFunction";
import { multiStudentcreateAction } from "../Redux/Action/studentAction";
import { adminListAction } from "../Redux/Action/manageAdminAction";
import CreateAdminModal from "../modals/CreateAdminModal";

export default function ManageAdmin() {
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState("");
  const [showCreate, setShowCreate] = useState(false);
  const [department, setDepartment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const FilterPayload = {
    searchValue: searchValue,
    selectedDepartment: department,
  };

  useEffect(() => {
    dispatch(resetTeacherAction());
    setIsLoading(true);
    dispatch(adminListAction(FilterPayload)).finally(() => {
      setIsLoading(false);
    });
    return () => {
      dispatch(resetTeacherAction());
    };
  }, [searchValue, department]);

  const adminListData = useSelector((state) => state?.manageAdminSlice?.admins);

  const handleCloseCreate = () => {
    setShowCreate(false);
    dispatch(adminListAction(FilterPayload));
  };
  const handleOpenCreate = () => {
    setShowCreate(true);
  };

  const handleDetailClick = (data) => {

    navigate(`/admin-detail/${Encryptedid(data?._id)}`);
  };





  const handleuploadcsv = async (event, type) => {
    const file = event.target.files[0];
    try {
      setIsLoading(true);

      let parsedData = [];
      parsedData = await uploadSchoolAdminCSV(file);

      if (parsedData.length === 0) {
        toast.error(
          "Invalid CSV file. Please ensure the correct headers are present."
        );
        setIsLoading(false);
        return;
      }

      const payload = {
        data: parsedData,
      };

      const response = await dispatch(multiSchoolAdmincreateAction(payload));

      if (response?.payload?.statusCode === 200) {
        toast.success(response?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        dispatch(adminListAction(FilterPayload));
      } else {
        toast.error(response?.payload?.message);
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error uploading and parsing CSV:", error);
      toast.error(
        "Invalid CSV file. Please ensure the correct headers and data are present."
      );
      setIsLoading(false);
    }
  };

  const handleButtonClickTeacher = () => {
    document.getElementById("fileInputSchoolAdmin").click();
  };

  const fieldsToSchoolAdminListExport = [
    "firstName",
    "surName",
    "department",
    "email",
  ];


  const filteredSchoolAdminListRecords = (records) => {
    return records.map((record) => {
      const filteredRecord = {};
      fieldsToSchoolAdminListExport.forEach((field) => {
        filteredRecord[field] = record[field]; // Only include selected fields
      });
      return filteredRecord;
    });
  };


  const schoolAdminListRecords =
    Array.isArray(adminListData.admin) && adminListData.admin.length > 0
      ? adminListData.admin
      : [];


  const schoolAdminListData = filteredSchoolAdminListRecords(
    schoolAdminListRecords
  );

  return (
    <Layout>
      <TopHeader setSearchValue={setSearchValue} groupData={[]} type="Class" />

      <div className="heading-top mt-5 mb-2">
        <h2> All Admins</h2>
      </div>
      <Container fluid>
        <Row>
          <Col lg={5}>
            {" "}
            <SearchBar setSearchValue={setSearchValue} />
          </Col>
          <Col lg={2}></Col>
          <Col lg={5} className="cud-btns d-flex justify-content-end gap-2">
            <button className="cmn-pink" onClick={handleOpenCreate}>
              Create New
            </button>

            {userData?.role == "School" && (
              <>
                <button className="cmn-sky" onClick={handleButtonClickTeacher}>
                  Upload CSV
                  <input
                    type="file"
                    onChange={(e) => handleuploadcsv(e, "schoolAdmin")}
                    id="fileInputSchoolAdmin"
                    style={{
                      display: "none",
                    }}
                  />
                </button>
              </>
            )}

            {userData?.role == "School" && (
              <>
                <button className="modal-f-btn btn btn-primary download-csv">
                  <CSVLink
                    data={schoolAdminListData}
                    filename="schoolAdmin.csv"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    Download CSV
                  </CSVLink>
                </button>
              </>
            )}
          </Col>
        </Row>
      </Container>
      <Container fluid>
        {isLoading ? (
          <LoaderComponent />
        ) : adminListData &&
          adminListData.admin &&
          adminListData.admin.length > 0 ? (
          <div className="students-main">
            {adminListData.admin.map((ele, index) => {
              return (
                <div
                  className="students-list"
                  onClick={() => handleDetailClick(ele)}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  <img
                    src={
                      ele.image
                        ? ele.image
                        : require("../Assets/Images/girl.png")
                    }
                  />
                  <h3>
                    {ele.firstName} {ele.surName}
                  </h3>
                  <p>{ele.department}</p>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="data-not-found">
            <p>No Data Found</p>
          </div>
        )}
      </Container>
      <CreateAdminModal
        showCreate={showCreate}
        handleCloseCreate={handleCloseCreate}
        editdata={null}
      />
    </Layout>
  );
}
